import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// NProgress
import 'nprogress/nprogress.css'

// Notify
import Notifications from '@kyvg/vue3-notification'

const vuetify = createVuetify({
  components,
  directives,
  iconfont: 'mdi'
})

createApp(App).use(vuetify).use(store).use(router).use(Notifications).mount('#app')
